import styled from 'styled-components';
import { onPhone } from '../../theme/tokens';

const TONES = {
  danger: '#cf1322',
  warning: '#d46b08',
  info: '#0958d9',
  default: '#8c8c8c'
};

export const BellButton = styled.button`
  position: relative;
  width: 44px;
  height: 44px;
  flex: none;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #595959;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${onPhone} {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }
`;

export const BellBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #a8071a;
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
  font-variant-numeric: tabular-nums;
  ${onPhone} {
    font-size: 12px;
  }
`;

export const ClickAway = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
`;

export const AlertPop = styled.div`
  position: absolute;
  top: 52px;
  right: 16px;
  width: 420px;
  max-width: calc(100vw - 24px);
  z-index: 65;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 18px 48px rgba(11, 20, 38, 0.28);
  overflow: hidden;
  color: #2c3e50;

  .ap-head {
    padding: 16px 18px 12px;
    border-bottom: 1px solid #f0f0f0;
  }
  .ap-title {
    font-size: 15px;
    font-weight: 700;
  }
  .ap-sub {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 2px;
  }
  .ap-list {
    max-height: 360px;
    overflow-y: auto;
  }
  .ap-empty {
    padding: 24px 18px;
    text-align: center;
    color: #8c8c8c;
    font-size: 13px;
  }
  .ap-row {
    display: flex;
    gap: 12px;
    width: 100%;
    text-align: left;
    padding: 12px 18px;
    border: none;
    border-bottom: 1px solid #f5f5f5;
    background: #fff;
    cursor: pointer;
    transition: background 0.15s ease;
  }
  .ap-row:hover {
    background: #fafafa;
  }
  .ap-dot {
    color: #cf1322;
    font-size: 15px;
    margin-top: 2px;
  }
  .ap-body {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
  }
  .ap-name {
    font-size: 13px;
    font-weight: 600;
  }
  .ap-meta {
    font-size: 12px;
    color: #8c8c8c;
  }
  .ap-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    margin-top: 2px;
  }
  .ap-past {
    font-size: 11px;
    font-weight: 700;
    color: #cf1322;
    background: #fff1f0;
    border-radius: 999px;
    padding: 1px 8px;
  }
  .ap-due {
    font-size: 11px;
    font-weight: 600;
  }
  ${Object.entries(TONES)
    .map(([k, v]) => `.ap-due.tone-${k} { color: ${v}; }`)
    .join('\n')}
  .ap-sla {
    font-size: 11px;
    color: #8c8c8c;
  }
  .ap-cta {
    width: 100%;
    padding: 13px;
    border: none;
    border-top: 1px solid #f0f0f0;
    background: #fff;
    color: #1e3a5f;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }
  .ap-cta:hover {
    background: #f5f8ff;
  }
`;
